import { Toast } from 'vant';
import _ from 'lodash';

const vipkidJsBridge = {
  scheme: 'vkappbridge',
  parseQuerystring(obj) {
    let result = '';
    if (obj) {
      let tmp = ['?'];
      _.map(obj, (value, key) => {
        if (value instanceof Array && value.length) {
          value.forEach((v) => {
            tmp.push(`${key}=${encodeURIComponent(v)}`);
          })
        } else {
          tmp.push(`${key}=${encodeURIComponent(value)}`);
        }
      });
      result = `?${tmp.join('&')}`;
    }
    return result;
  },
  callNativeMethod(action, data) {
    const scheme = this.scheme;
    let queryStr = this.parseQuerystring(data);
    let url = `${scheme}://${action}${queryStr}`;
    let iframe = document.createElement('iframe');
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    setTimeout(function() {
      iframe.remove();
    }, 300);
  },
  putData: function(action, data, callback) {
    const scheme = this.scheme;
    const self = this;
    // 解决连续调用问题
    if (this.lastCallTime && (Date.now() - this.lastCallTime) < 100) {
      setTimeout(function() {
        self.doCall(action, data, callback);
      }, 100);
      return;
    }
    this.lastCallTime = Date.now();
    data = data || {};
    if (callback) {
      _.assignIn(data, { callback: callback })
    }
    if (self.isIOS()) {
      let queryStr = this.parseQuerystring(data);
      let url = `${scheme}://${action}${queryStr}`;
      // var url = Args.addParameter(`${scheme}://${action}`, data);
      let iframe = document.createElement('iframe');
      iframe.style.width = '1px';
      iframe.style.height = '1px';
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(function() {
        iframe.remove();
      }, 100);
    } else if (self.isAndroid()) {
      const func = _.get(window, `${scheme}.${action}`);
      func && window[scheme][action](JSON.stringify(data));
    } else {
      console.error('未获取platform信息，调取api失败');
    }
  },
  isIOS() {
    return /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent); // 判断iPhone|iPad|iPod|iOS
  },
  isAndroid() {
    return /(Android)/i.test(window.navigator.userAgent); // 判断Android
  },
  isVkhybrid() {
    return /(vkhybrid)/i.test(window.navigator.userAgent); // 判断native webview.loadurl方式
  },
  // url '://isso.vipkid.com.cn'
  // data {url: '', query: {}}
  openUrl(data) {
    const { url, query } = data;
    let queryStr = this.parseQuerystring(query);
    location.href = `${url}${queryStr}`
  },
  trigger(action, data) {
    this.hasOwnProperty(action) && this[action](data);
  }
};

export const notifyNativeLoggedSuccessfully = token => {
  return vipkidJsBridge.callNativeMethod('login/login', {
    key: 'ssoToken',
    value: token
  })
};

export const isVkhybrid = vipkidJsBridge.isVkhybrid();

export const setNavBarHidden = data => {
  return isVkhybrid && vipkidJsBridge.callNativeMethod('navigationbar/setNavBarHidden', data)
};

export function navigationTo(url, appSsoToken) {
  if (isVkhybrid && appSsoToken) {
    return notifyNativeLoggedSuccessfully(appSsoToken);
  }
  let sourceUrl = url || localStorage.getItem('redirectSourceUrl');
  if (!sourceUrl) {
    return Toast('来源地址redirectUrl为空');
  }
  return location.replace(sourceUrl);
}
